import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Badge,
  Form,
  Table,
} from "react-bootstrap";
import { studyEventFormSchemaServices } from "../../../APIServices/studyEventFormSchemaServices";
import { useParams } from "react-router";
import { studyLevelFormManagementServices } from "../../../APIServices/studyLevelFormManagementServices";
import Swal from "sweetalert2";
import { PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import { eiwrsDepotManagementServices } from "../../../APIServices/EIWRS/eiwrsDepotManagementServices";
import { studySiteManagementServices } from "../../../APIServices/CTMS/SiteManagement/studySiteManagementServices";
import { eiwrsSiteInventoryServices } from "../../../APIServices/EIWRS/eiwrsSiteInventoryServices";

const AssignDepotSite = () => {
  const [siteId, setSiteId] = useState("");
  const [depotList, setDepotList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [leftLoading, setLeftLoading] = useState(false);
  const [rightLoading, setRightLoading] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [siteList, setSiteList] = useState([]);
  const [siteDepotMatrix, setSiteDepotMatrix] = useState([]);
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const LoginCat = JSON.parse(localStorage.getItem("role")).toLowerCase();
  const [addedDepots, setAddedDepots] = useState([]);

  const handleAddForm = (depot) => {
    if (
      !addedDepots.some((item) => {
        const sameForm =
          item.depotId === depot.depotId &&
          item.siteId === siteId;
        if (!sameForm) return false;
      })
    ) {
      setAddedDepots((prev) => [
        ...prev,
        {
          depotId: depot.depotId,
          studyId,
          siteId,
        },
      ]);
    }
  };

  const handleRemoveDepot = (depotId) => {
    setAddedDepots((prev) =>
      prev.filter((item) => item.depotId !== depotId)
    );
  };

  const assignUnassignStudyDepotSite = async (
    depot,
    type
  ) => {
    setButtonLoader(true);
    let userData = {};
    userData.studyId = studyId;
    userData.siteId = siteId;
    userData.depotId = depot?.depotId;
    userData.type = type;
    let data = await eiwrsSiteInventoryServices.assignUnassignStudyDepotSite(
      userData
    );
    if (data?.statusCode === 200) {
      getAssignedDepotBySite()
      if (type === "assigne") {
        handleAddForm(depot);
      } else {
        handleRemoveDepot(
          depot.depotId,
        );
      }
    }
    setButtonLoader(false);
  };

  const getStudySiteBasedonAccess = async (e) => {
    let data = await studySiteManagementServices.getStudySiteBasedonAccess(
      studyId, LoginCat, StudyMode
    );
    setSiteList(data?.data || []);
    setSiteId(data?.data?.[0]?.siteId || "");
  };

  const getStudyDepotRowData = async (e) => {
    setRightLoading(true);
    let data = await eiwrsDepotManagementServices.getStudyDepotRowData(
      "active",
      studyId,
      StudyMode
    );
    setDepotList(data?.data || []);
    setRightLoading(false);
  };

  const getAssignedDepotBySite = async (e) => {
    setLeftLoading(true);
    let data = await eiwrsSiteInventoryServices.getAssignedDepotBySite(
      studyId,
      siteId,
    );
    setAddedDepots(data?.data || []);
    setSiteDepotMatrix(data?.matrixData || []);
    setLeftLoading(false);
  };

  useEffect(() => {
    if (siteId) {
      getAssignedDepotBySite();
    }
  }, [siteId]);

  useEffect(() => {
    getStudySiteBasedonAccess()
    getStudyDepotRowData()
  }, []);

  const exportMatrixCSV = () => {
    const headers = [
      "Depot",
      ...siteList.map((site) => `"${site.row.SITEID}"`),
    ];

    const rows = depotList.map((depot) => {
      const row = [
        `"${depot?.row?.DEPOTID} (${depot?.row?.DEPOTNAME})"`,
      ];

      siteList.forEach((site) => {
        const exists = siteDepotMatrix.some(
          (item) =>
            item.siteId === site.siteId &&
            item.depotId === depot.depotId
        );

        row.push(exists ? "○" : "·");
      });

      return row.join(",");
    });

    const csvContent = [headers.join(","), ...rows].join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `Site_Depot_Matrix.csv`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  return (
    <div className="overflow-auto" style={{ height: "calc(100vh - 144px)" }}>
      <Container fluid className="py-3">
        <Row className="mb-3">
          <Col md={7}>
            <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
              <div className="bg-light p-2 border-bottom hstack justify-content-between">
                <span className="fw-bold">Assigned Depot Site</span>{" "}
                <div className="d-flex align-items-center gap-2">
                  <Form.Label className="text-muted mb-0">Site:</Form.Label>
                  <Form.Select
                    onChange={(e) => setSiteId(e.target.value)}
                    value={siteId}
                    disabled={siteList?.length === 0}
                    size="sm" style={{ flex: 1 }}>
                    {siteList?.length > 0 ? (
                      siteList?.map((item, index) => (
                        <option
                          selected={siteId === item?.siteId}
                          key={index}
                          value={item?.siteId}
                        >
                          {item?.row?.SITEID}
                        </option>
                      ))
                    ) : (
                      <option value={""}>No Site</option>
                    )}
                  </Form.Select>
                </div>
              </div>
              <Card.Body>
                <div className="d-flex flex-wrap gap-2">
                  {leftLoading ?
                    <PageLoader />
                    : addedDepots.map((item) => {
                      const depot = depotList.find(
                        (f) =>
                          f.depotId === item.depotId
                      );

                      return (
                        <Badge
                          key={item.depotId}
                          pill
                          className="hstack gap-2 text-dark"
                          bg="primary-subtle"
                        >
                          <small>
                            {depot?.row?.DEPOTID}
                          </small>

                          <Button
                            variant="link"
                            size="sm"
                            className="p-0 text-danger"
                            style={{ textDecoration: "none" }}
                            onClick={() => {
                              assignUnassignStudyDepotSite(
                                item,
                                "unassigne"
                              )
                            }}
                          >
                            ×
                          </Button>
                        </Badge>
                      );
                    })}
                  {addedDepots.length === 0 && (
                    <div className="text-muted text-center w-100 py-3">
                      No depots added. Click a form depot the library to add.
                    </div>
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* Right Panel - Form Library */}
          <Col md={5}>
            <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
              <div className="bg-light p-2 border-bottom hstack justify-content-between">
                <span className="fw-bold">Depot library</span>{" "}
                <span className="text-muted small">Click a Depot to add it to the selected visit.</span>{" "}
              </div>
              <Card.Body>
                <div
                  className="d-flex flex-wrap gap-2"
                  style={{ maxHeight: "400px", overflowY: "auto" }}
                >
                  {rightLoading ?
                    <PageLoader />
                    : depotList.map((depot) => {
                      const isAdded = addedDepots.some(
                        (f) => f.depotId === depot.depotId
                      );
                      return (
                        <Badge
                          key={depot.depotId}
                          pill
                          className="hstack gap-2 text-dark"
                          bg={(!isAdded && siteId) ? "primary-subtle" : "secondary-subtle"}
                          style={{
                            cursor: (!isAdded && siteId) ? "pointer" : "default",
                            opacity: (!isAdded && siteId) ? 1 : 0.7,
                          }}
                          onClick={() => {
                            if (!isAdded && siteId) {
                              assignUnassignStudyDepotSite(
                                depot,
                                "assigne"
                              );
                            }
                          }}
                        >
                          <small>{depot.row.DEPOTID}</small>
                          {!isAdded ? (
                            <span className="ms-1 text-primary"> + </span>
                          ) : (
                            <span className="ms-1 text-success"> ✓</span>
                          )}
                        </Badge>
                      );
                    })}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {/* Site × Depot matrix */}
        <Row className="mb-3">
          <Col xs={12}>
            <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
              <div className="bg-light p-2 hstack justify-content-between">
                <span className="fw-bold">Site × Depot matrix</span>
                <button onClick={exportMatrixCSV} className="updateProfile" size="sm">
                  Export matrix
                </button>
              </div>
              <Card.Body className="p-0" style={{ overflowX: "auto" }}>
                {loading ?
                  <PageLoader />
                  :
                  <>
                    <Table bordered hover size="sm" className="mb-0" style={{ fontSize: "12px", minWidth: "800px" }}>
                      <thead className="position-sticky top-0 z-1">
                        <tr>
                          <th style={{ position: "sticky", left: 0, background: "#f8f9fa", zIndex: 1 }}>Depot</th>
                          {siteList.map((site) => (
                            <th key={site.siteId} className="text-center" style={{ minWidth: "60px" }}>
                              <div>{site.row.SITEID}</div>
                              {site.row.SITENAME &&
                                <div style={{ fontSize: "9px", color: "#8aa1a9" }}>{site.row.SITENAME}</div>
                              }
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {depotList.map((depot) => {
                          const hasDepot = addedDepots.some(item => (item?.depotId === depot.depotId));
                          return (
                            <tr key={depot.id}>
                              <td style={{
                                position: "sticky",
                                left: 0,
                                background: "white",
                                zIndex: 1,
                                fontWeight: "500",
                                fontSize: "12px"
                              }}>
                                {depot.row.DEPOTID}
                              </td>
                              {siteList.map((site, colIndex) => {
                                const exists = siteDepotMatrix.some(
                                  (item) =>
                                    item.siteId === site.siteId &&
                                    item.depotId === depot.depotId
                                );

                                return (
                                  <td key={colIndex} className="text-center">
                                    {exists ? (
                                      <span
                                        style={{
                                          color: "#52707a",
                                          fontSize: 16,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        ○
                                      </span>
                                    ) : (
                                      <span style={{ color: "#d8e1e5" }}>·</span>
                                    )}
                                  </td>
                                );
                              })}
                            </tr>
                          )
                        })}
                      </tbody>
                    </Table>
                    <div className="d-flex gap-3 p-2" style={{ fontSize: "11px", color: "#52707a" }}>
                      <span><span style={{ color: "#52707a", fontWeight: "bold" }}>○</span> Assigned Depot</span>
                      <span><span style={{ color: "#d8e1e5" }}>·</span> Not Assigned Depot</span>
                    </div>
                  </>
                }
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AssignDepotSite;